import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1649415d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./styles/pinkki.less?vue&type=style&index=0&prod&lang=less&external"
import style1 from "./App.vue?vue&type=style&index=1&id=1649415d&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.44_css-loader@6.11.0_webpack@5.112.0_postcss@8_3f3a1ecdcd5f78252cb4636facbad37f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports